import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import imageCompression from "browser-image-compression";
import Swal from "sweetalert2";

export default function Compeditpemain() {
  const urlapi = process.env.REACT_APP_BASE_URL;
  const upload_preset = process.env.REACT_APP_UPLOAD_PRESET_RANKTEAM;
  const cloud_name = process.env.REACT_APP_CLOUD_NAME_RANKTEAM;

  const { id } = useParams();
  const [pemain, setPemain] = useState([]);
  const [nama, setNama] = useState("");
  const [nickname, setNickname] = useState("");
  const [posisi, setPosisi] = useState("");
  const [nopunggung, setNopunggung] = useState("");
  const [nik, setNik] = useState("");
  const [nikuser, setNikuser] = useState("");
  const [notifnik, setNotifnik] = useState(false);
  const [panjangnik, setPanjangnik] = useState("");
  const [previewktp, setPreviewktp] = useState(null);
  const [previewfoto, setPreviewfoto] = useState(null);
  const [filektp, setFilektp] = useState(null);
  const [filefoto, setFilefoto] = useState(null);
  const [loadingktp, setLoadingktp] = useState(false);
  const [loadingfoto, setLoadingfoto] = useState(false);
  const [ktp, setKtp] = useState("");
  const [foto, setFoto] = useState("");

  const navigate = useNavigate();

  const getPemain = async () => {
    try {
      const response = await axios.get(
        urlapi + "Pemainrankteam?idpemain=" + id,
      );
      //   console.log(response.data);
      setPemain(response.data);
      setNama(response.data.nama);
      setPosisi(response.data.posisi);
      setNopunggung(response.data.no_punggung);
      setNickname(response.data.nickname);
      setNik(response.data.nik);
      setNikuser(response.data.nik);
      setPreviewktp(response.data.ktp);
      setPreviewfoto(response.data.foto);
    } catch (error) {}
  };

  const handleubahpemain = async () => {
    if (!filektp && !filefoto) {
      ubahPemain(previewktp, previewfoto);
      return;
    }

    Swal.fire({
      title: "Mengupload...",
      text: "Data anda sedang di proses.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(); // animasi loading SweetAlert
      },
    });

    const uploadImage = async (file) => {
      const data = new FormData();
      data.append("file", file);
      data.append("upload_preset", upload_preset);
      data.append("cloud_name", cloud_name);

      const res = await fetch(
        `https://api.cloudinary.com/v1_1/${cloud_name}/image/upload`,
        {
          method: "POST",
          body: data,
        },
      );
      return await res.json();
    };

    try {
      // Upload keduanya paralel agar lebih cepat
      const [uploadKtp, uploadPemain] = await Promise.all([
        uploadImage(filektp),
        uploadImage(filefoto),
      ]);

      console.log("KTP:", uploadKtp.secure_url);
      console.log("Foto Pemain:", uploadPemain.secure_url);

      // contoh simpan hasilnya
      const dataToSend = {
        ktp: uploadKtp.secure_url,
        foto_pemain: uploadPemain.secure_url,
      };

      console.log("Data siap dikirim ke backend:", dataToSend);
      if (!filefoto && filektp) {
        ubahPemain(uploadKtp.secure_url, previewfoto);
      } else if (filefoto && !filektp) {
        ubahPemain(previewktp, uploadPemain.secure_url);
      } else {
        ubahPemain(uploadKtp.secure_url, uploadPemain.secure_url);
      }
    } catch (error) {
      console.error("Upload gagal:", error);
    }
  };

  const ubahPemain = async (ktp, foto) => {
    await axios
      .post(urlapi + "Ubahpemainrankteam", {
        id: id,
        nama: nama,
        posisi: posisi,
        no_punggung: nopunggung,
        nik: nik,
        nickname: nickname,
        ktp: ktp,
        foto: foto,
      })
      .then((response) => {
        // console.log(response.data);
        Swal.close();
        notify();
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const notify = () =>
    toast.success("Data berhasil diubah !", {
      position: toast.POSITION.TOP_CENTER,
    });

  const handleFileChangeKTP = async (e) => {
    const uploadedFile = e.target.files[0];
    const options = {
      maxSizeMB: 1, // Maksimum ukuran gambar dalam MB
      maxWidthOrHeight: 800, // Dimensi maksimum
      useWebWorker: true,
    };
    setFilektp(uploadedFile);
    try {
      const compressedFile = await imageCompression(uploadedFile, options);
      console.log(compressedFile);

      // 🔄 Convert hasil kompres ke WebP
      const webpBlob = await convertToWebP(compressedFile);
      const webpFile = new File([webpBlob], "compressed.webp", {
        type: "image/webp",
      });
      setFilektp(webpFile);
      if (compressedFile != null) {
        setLoadingktp(true);
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewktp(reader.result);
        };
        reader.readAsDataURL(webpFile);
      }
    } catch (error) {
      console.error("Gagal mengompres gambar:", error);
    }
  };

  const handleFileChangeFoto = async (e) => {
    const uploadedFile = e.target.files[0];
    const options = {
      maxSizeMB: 1, // Maksimum ukuran gambar dalam MB
      maxWidthOrHeight: 800, // Dimensi maksimum
      useWebWorker: true,
    };
    setFilefoto(uploadedFile);
    try {
      const compressedFile = await imageCompression(uploadedFile, options);
      console.log(compressedFile);

      // 🔄 Convert hasil kompres ke WebP
      const webpBlob = await convertToWebP(compressedFile);
      const webpFile = new File([webpBlob], "compressed.webp", {
        type: "image/webp",
      });

      setFilefoto(webpFile);
      if (compressedFile != null) {
        setLoadingfoto(true);
        if (uploadedFile) {
          const reader = new FileReader();
          reader.onloadend = () => {
            setPreviewfoto(reader.result);
          };
          reader.readAsDataURL(webpFile);
        }
      }
    } catch (error) {
      console.error("Gagal mengompres gambar:", error);
    }
  };

  const convertToWebP = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        canvas.toBlob(
          (blob) => (blob ? resolve(blob) : reject("Gagal konversi ke WebP")),
          "image/webp",
          0.8, // kualitas (0.1 - 1)
        );
      };

      img.onerror = reject;
    });
  };

  const handlenik = (e) => {
    setNik(e);
    ceknik(e);

    if (e.length == 16) {
      setPanjangnik("true");
    } else if (e.length > 16) {
      setPanjangnik("false1");
    } else if (e.length < 16) {
      setPanjangnik("false2");
    }
    // console.log(e);
  };

  const ceknik = async (nik) => {
    try {
      const response = await axios.get(urlapi + "Ceknik?nik=" + nik);
      // console.log(response.data);
      if (response.data == "" || nik == nikuser) {
        setNotifnik(false);
      } else {
        setNotifnik(true);
      }
    } catch (error) {
      setNotifnik(false);
    }
  };

  useEffect(() => {
    getPemain();
  }, []);
  return (
    <div className="my-5">
      <br></br>
      <div className="container">
        <div className="card border-0" id="bggradient1">
          <div className="card-body text-white">
            <h5 className="fw-bold">Ubah Pemain rank team anda</h5>
            <small>Ubah pemain rank team anda</small>
          </div>
        </div>
        <div className="card mt-3">
          <div className="card-body">
            <p className="fw-bold text-secondary">
              <i className="fas fa-user"></i> Form ubah data pemain
            </p>
            <hr />
            <div className="row">
              <div className="col-sm-6 col-6">
                <div className="form-group">
                  <label className="mb-1 fw-bold">Nama</label>
                  <input
                    className="form-control text-secondary"
                    onChange={(e) => setNama(e.target.value)}
                    name="nama"
                    value={nama}
                  />
                </div>
              </div>
              <div className="col-sm-6 col-6">
                <div className="form-group">
                  <label className="mb-1 fw-bold">Posisi</label>
                  <select
                    className="form-control text-secondary"
                    name="posisi"
                    onChange={(e) => setPosisi(e.target.value)}
                  >
                    <option>{pemain.posisi}</option>
                    <option value="">-- Pilih Posisi --</option>
                    <option>Penyerang</option>
                    <option>Gelandang serang</option>
                    <option>Gelandang sayap</option>
                    <option>Gelandang tengah</option>
                    <option>Bek sayap</option>
                    <option>Bek tangah</option>
                    <option>Penjaga gawang</option>
                  </select>
                </div>
              </div>
              <div className=" mt-3 col-sm-12 col-12">
                <div className="form-group">
                  <label className="mb-1 fw-bold">NIK</label>
                  <input
                    className="form-control text-secondary"
                    onChange={(e) => handlenik(e.target.value)}
                    name="nickname"
                    value={nik}
                  />
                </div>
                {notifnik == true ? (
                  <>
                    <small className="text-danger">
                      Nik yang anda masukan sudah terdaftar
                    </small>
                  </>
                ) : (
                  ""
                )}
                <div></div>
                {panjangnik == "true" ? (
                  <>
                    <small className="text-success">
                      Panjang nik sudah benar
                    </small>
                  </>
                ) : panjangnik == "false1" ? (
                  <>
                    <small className="text-danger">Nik terlalu panjang</small>
                  </>
                ) : panjangnik == "false2" ? (
                  <>
                    <small className="text-danger">Nik terlalu pendek</small>
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className="col-sm-6 col-6 mt-3">
                <label htmlFor="" className="fw-bold">
                  Foto KTP
                </label>
                <div className="text-center border rounded-3 p-4 bg-light position-relative">
                  <label
                    htmlFor="formFile"
                    className="form-label fw-semibold w-100 d-block"
                    style={{ cursor: "pointer" }}
                  >
                    {previewktp ? (
                      <>
                        <img
                          src={previewktp}
                          alt="Preview"
                          className="img-fluid rounded shadow-sm"
                          style={{
                            maxHeight: "200px",
                            objectFit: "contain",
                            border: "2px solid #007bff",
                          }}
                        />
                        <div
                          className="mt-1 text-secondary"
                          style={{ fontSize: "11px" }}
                        >
                          Klik atau seret file untuk upload ktp
                        </div>
                      </>
                    ) : (
                      <>
                        <i className="fas fa-file text-primary fs-3"></i>
                        <div
                          className="text-primary"
                          style={{ fontSize: "11px" }}
                        >
                          {loadingktp == true ? "Loading ..." : ""}
                        </div>
                        <div
                          className="text-secondary"
                          style={{ fontSize: "11px" }}
                        >
                          Klik atau seret file untuk upload ktp
                        </div>
                      </>
                    )}
                  </label>

                  <input
                    className="form-control d-none"
                    type="file"
                    id="formFile"
                    accept=".jpg, .jpeg, .png"
                    onChange={handleFileChangeKTP}
                  />
                </div>
                {/* <small className="text-secondary" style={{ fontSize: '10px' }}>Format KTP pemain harus berformat gambar (jpg, jpeg, png)</small> */}
              </div>
              <div className="col-sm-6 col-6 mt-3">
                <label htmlFor="" className="fw-bold">
                  Foto Pemain
                </label>
                <div className="text-center border rounded-3 p-4 bg-light position-relative">
                  <label
                    htmlFor="formFile2"
                    className="form-label fw-semibold w-100 d-block"
                    style={{ cursor: "pointer" }}
                  >
                    {previewfoto ? (
                      <>
                        <img
                          src={previewfoto}
                          alt="Preview"
                          className="img-fluid rounded shadow-sm"
                          style={{
                            maxHeight: "200px",
                            objectFit: "contain",
                            border: "2px solid #007bff",
                          }}
                        />
                        <div
                          className="mt-1 text-secondary"
                          style={{ fontSize: "11px" }}
                        >
                          Klik atau seret file untuk upload foto
                        </div>
                      </>
                    ) : (
                      <>
                        <i className="fas fa-file text-primary fs-3"></i>
                        <div
                          className="text-primary"
                          style={{ fontSize: "11px" }}
                        >
                          {loadingfoto == true ? "Loading ..." : ""}
                        </div>
                        <div
                          className="text-secondary"
                          style={{ fontSize: "11px" }}
                        >
                          Klik atau seret file untuk upload foto
                        </div>
                      </>
                    )}
                  </label>

                  <input
                    className="form-control d-none"
                    type="file"
                    id="formFile2"
                    accept=".jpg, .jpeg, .png"
                    onChange={handleFileChangeFoto}
                  />
                </div>
                {/* <small className="text-secondary" style={{ fontSize: '10px' }}>Format foto pemain harus berformat gambar (jpg, jpeg, png)</small> */}
              </div>
            </div>
            <div className="mt-3">
              <div className="d-flex justify-content-between">
                {nama == "" ||
                nik == "" ||
                posisi == "" ||
                notifnik == true ||
                panjangnik == "false1" ||
                panjangnik == "false2" ? (
                  <>
                    {" "}
                    <button
                      className="btn  mt-4 w-100 border-0 text-white rounded-pill"
                      disabled
                      style={{
                        marginRight: "10px",
                        backgroundColor: "#2b2e5a",
                      }}
                    >
                      Ubah data
                    </button>
                  </>
                ) : (
                  <>
                    {" "}
                    <button
                      className="btn  mt-4 w-100 border-0 text-white rounded-pill"
                      style={{
                        marginRight: "10px",
                        backgroundColor: "#2b2e5a",
                      }}
                      onClick={() => handleubahpemain()}
                    >
                      <i className="fas fa-pen"></i> Ubah data
                    </button>
                  </>
                )}

                <Link
                  onClick={() => navigate(-1)}
                  className="btn  mt-4 w-100 border-0 rounded-pill text-white"
                  style={{ backgroundColor: "#2b2e5a" }}
                >
                  <i className="fas fa-angle-left"></i> Kembali
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
